import { useNavigate } from "react-router-dom";
import { Routes } from "../../navigation";
import { UnauthorizedPageCmp } from "./types";
import { Button } from "ui/components/Button/Button";

const UnauthorizedPage: UnauthorizedPageCmp = () => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="max-w-md w-full bg-white shadow-xl rounded-lg p-8">
        <div className="flex flex-col items-center text-center">
          <div className="mb-6">
            <svg
              className="w-20 h-20 text-yellow-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 15v.01M12 9v3m0-9a9 9 0 100 18 9 9 0 000-18z"
              />
            </svg>
          </div>

          <h1 className="text-3xl font-bold text-gray-800 mb-3">
            Nemate pristup
          </h1>

          <p className="text-gray-600 mb-6">
            Nemate dozvolu za pristup ovoj stranici. Kontaktirajte administratora ako mislite da je ovo greška.
          </p>

          <div className="flex gap-3 w-full">
            <Button
              onClick={() => navigate("/")}
              variant="primary"
              size="full"
            >
              Početna stranica
            </Button>

            <Button
              onClick={() => navigate(-1 as any)}
              variant="outlined"
              size="full"
            >
              Natrag
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

UnauthorizedPage.route = Routes.UnauthorizedPage;

export default UnauthorizedPage;
